import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin.js';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

// ScrollTrigger
// ==================================================================

// 要素の位置スクロールまでスクロールしてクラスを付与
// ---------------------------------------------------------
document.querySelectorAll('[data-scroll]').forEach((el, i) => {
	ScrollTrigger.create({
		trigger: el,
		id: i + 1,
		start: 'top 80%',
		toggleClass: { targets: el, className: '-show' },
		once: true,
	});
});
